module.exports = __webpack_public_path__ + "static/media/App_Graphic.dd9faeeb.png";